// Конфигурация API
const API_BASE_URL = import.meta.env.VITE_API_URL || '/api';

// Таймауты для запросов
export const API_TIMEOUT = 30000; // 30 секунд

// Эндпоинты API (полный список согласно документации)
export const API_ENDPOINTS = {
  // --- 1. Аутентификация и пользователи (Auth & Users) ---
  LOGIN: `${API_BASE_URL}/auth/login`,
  LOGOUT: `${API_BASE_URL}/auth/logout`,
  REFRESH_TOKEN: `${API_BASE_URL}/auth/refresh`,
  AUTH_ME: `${API_BASE_URL}/auth/me`,
  USERS: `${API_BASE_URL}/users`,
  USER: (id) => `${API_BASE_URL}/users/${id}`,
  USERS_ROLES: `${API_BASE_URL}/users/roles`,
  USER_PASSWORD: `${API_BASE_URL}/users/password`,
  USER_PASSWORD_RESET: (id) => `${API_BASE_URL}/users/${id}/password`,
  EMPLOYEES_WITHOUT_ACCOUNT: `${API_BASE_URL}/users/employees-without-account`,

  // --- 2. Обучения (Trainings) ---
  TRAININGS_EXPIRED: `${API_BASE_URL}/trainings/expired`,
  TRAININGS_EXPIRING: (days) => `${API_BASE_URL}/trainings/expiring/${days}`,
  TRAINING: (id) => `${API_BASE_URL}/trainings/${id}`,
  TRAINING_EXTEND: (id) => `${API_BASE_URL}/trainings/${id}/extend`,
  TRAININGS_ASSIGN: `${API_BASE_URL}/trainings/assign`,
  TRAININGS_BULK_ASSIGN: `${API_BASE_URL}/trainings/bulk-assign`,
  TRAININGS_STATISTICS: `${API_BASE_URL}/trainings/statistics`,
  TRAININGS_EXPORT: `${API_BASE_URL}/trainings/export`,
  TRAININGS_SEARCH: `${API_BASE_URL}/trainings/search`,
  TRAININGS_EMPLOYEE: (employeeId) => `${API_BASE_URL}/trainings/employee/${employeeId}`,
  TRAININGS_BRIGADE: (brigadeId) => `${API_BASE_URL}/trainings/brigade/${brigadeId}`,
  TRAININGS_EMPLOYEE_COURSES_SUMMARY_SHOW: `${API_BASE_URL}/trainings/employee-courses-summary-show`,

  // Новые эндпоинты для работы с сертификатами и НПА
  TRAINING_CERTIFICATE: (id) => `${API_BASE_URL}/trainings/${id}/certificate`,
  TRAINING_CERTIFICATE_NUMBER: (id) => `${API_BASE_URL}/trainings/${id}/certificate-number`,
  TRAINING_REGULATORY_ACTS: (id) => `${API_BASE_URL}/trainings/${id}/regulatory-acts`,
  TRAININGS_DASHBOARD_SUMMARY: `${API_BASE_URL}/trainings/dashboard/summary`,
  TRAININGS_DASHBOARD_EXPIRED_BY_COURSE: `${API_BASE_URL}/trainings/dashboard/expired-by-course`,
  TRAININGS_DASHBOARD_EXPIRING_IN_MONTH: `${API_BASE_URL}/trainings/dashboard/expiring-in-month`,
  TRAININGS_DASHBOARD_EXPIRING_IN_TWO_MONTHS: `${API_BASE_URL}/trainings/dashboard/expiring-by-period?period=two_months`,

  // --- Мероприятия (Training Events) ---
  TRAINING_EVENTS: `${API_BASE_URL}/training-events`,
  TRAINING_EVENT: (id) => `${API_BASE_URL}/training-events/${id}`,
  TRAINING_EVENTS_CALENDAR: `${API_BASE_URL}/training-events/calendar`,
  TRAINING_EVENT_PARTICIPANTS: (id) => `${API_BASE_URL}/training-events/${id}/participants`,
  TRAINING_EVENT_PARTICIPANTS_REMOVE_BULK: (id) => `${API_BASE_URL}/training-events/${id}/participants/remove-bulk`,
  TRAINING_EVENTS_BY_COURSE: (courseId) => `${API_BASE_URL}/training-events/by-course/${courseId}`,
  TRAININGS_EMPLOYEE_COURSES_SUMMARY: `${API_BASE_URL}/trainings/employee-courses-summary`,

  // --- 3. Тепловая карта (HeatMap) ---
  HEATMAP: `${API_BASE_URL}/heatmap`,
  HEATMAP_EMPLOYEE: (employeeId) => `${API_BASE_URL}/heatmap/employee/${employeeId}`,
  HEATMAP_SUMMARY: `${API_BASE_URL}/heatmap/summary`,
  HEATMAP_EXPORT: `${API_BASE_URL}/heatmap/export`,
  HEATMAP_FILTERS: `${API_BASE_URL}/heatmap/filters`,

  // --- 4. Сотрудники (Employees) ---
  EMPLOYEES: `${API_BASE_URL}/employees`,
  EMPLOYEE: (id) => `${API_BASE_URL}/employees/${id}`,
  EMPLOYEES_BRIGADE: (brigadeId) => `${API_BASE_URL}/employees/brigade/${brigadeId}`,
  EMPLOYEES_SEARCH: `${API_BASE_URL}/employees/search`,
  EMPLOYEES_STATISTICS: `${API_BASE_URL}/employees/statistics`,
  EMPLOYEES_COMPLIANCE: `${API_BASE_URL}/employees/compliance`,
  EMPLOYEE_CHANGE_POSITION: (id) => `${API_BASE_URL}/employees/${id}/change-position`,

  // --- 5. Бригады (Brigades) ---
  BRIGADES: `${API_BASE_URL}/brigades`,
  BRIGADE: (id) => `${API_BASE_URL}/brigades/${id}`,
  BRIGADE_MEMBERS: (id) => `${API_BASE_URL}/brigades/${id}/members`,
  BRIGADE_MEMBER: (brigadeId, employeeId) => `${API_BASE_URL}/brigades/${brigadeId}/members/${employeeId}`,
  BRIGADES_STATISTICS: `${API_BASE_URL}/brigades/statistics`,

  // --- 6. Курсы и компетенции (Courses & Matrix) ---
  COURSES: `${API_BASE_URL}/courses`,
  COURSE: (id) => `${API_BASE_URL}/courses/${id}`,
  COURSES_CATEGORIES: `${API_BASE_URL}/courses/categories`,
  COURSES_REQUIRED: (positionId) => `${API_BASE_URL}/courses/required/${positionId}`,
  COURSE_EMPLOYEES: (courseId) => `${API_BASE_URL}/courses/${courseId}/employees`,
  COURSE_EVENTS: (courseId) => `${API_BASE_URL}/courses/${courseId}/events`,

  MATRIX_POSITIONS: `${API_BASE_URL}/matrix/positions`,
  MATRIX_POSITION_COURSE: (positionId, courseId) => `${API_BASE_URL}/matrix/positions/${positionId}/courses/${courseId}`,
  MATRIX_BRIGADE_COURSE: (brigadeId, courseId) => `${API_BASE_URL}/matrix/brigades/${brigadeId}/courses/${courseId}`,

  // --- 6.1 Подразделения (Departments) ---
  DEPARTMENTS: `${API_BASE_URL}/departments`,
  DEPARTMENT: (id) => `${API_BASE_URL}/departments/${id}`,

  // --- 7. Должности (Positions) ---
  POSITIONS: `${API_BASE_URL}/positions`,
  POSITION: (id) => `${API_BASE_URL}/positions/${id}`,
  POSITIONS_CATEGORIES: `${API_BASE_URL}/positions/categories`,
  POSITIONS_ALL: `${API_BASE_URL}/positions`,

  // --- 8. Уведомления (Notifications) ---
  NOTIFICATIONS: `${API_BASE_URL}/notifications`,
  NOTIFICATION_READ: (id) => `${API_BASE_URL}/notifications/${id}/read`,
  NOTIFICATIONS_MARK_ALL_READ: `${API_BASE_URL}/notifications/mark-all-read`,
  NOTIFICATIONS_UNREAD_COUNT: `${API_BASE_URL}/notifications/unread-count`,

  // --- 9. Процессы (Processes / Mobilization) ---
  PROCESSES: `${API_BASE_URL}/processes`,
  PROCESSES_MOBILIZATION: `${API_BASE_URL}/processes/mobilization`,
  PROCESSES_MOBILIZATION_DETAIL: (id) => `${API_BASE_URL}/processes/mobilization/${id}`,
  PROCESSES_MOBILIZATION_STAGE: (id) => `${API_BASE_URL}/processes/mobilization/${id}/stage`,
  PROCESS_STAGES: `${API_BASE_URL}/processes/stages`,
  SLA_TEMPLATES: `${API_BASE_URL}/processes/sla-templates`,

  // --- 10. Статистика и дашборд (Dashboard) ---
  DASHBOARD_STATS: `${API_BASE_URL}/dashboard/stats`,
  DASHBOARD_UPCOMING: `${API_BASE_URL}/dashboard/upcoming`,

  // --- Отчеты (Reports) ---
  COMPLIANCE_REPORT: `${API_BASE_URL}/reports/compliance`,
  EXPIRING_ALERTS: `${API_BASE_URL}/reports/expiring-alerts`,

  // --- Календарь (Calendar) ---
  CALENDAR_EVENTS: `${API_BASE_URL}/calendar/events`,
};

// Заголовки по умолчанию
export const getDefaultHeaders = () => ({
  'Content-Type': 'application/json',
  'Accept': 'application/json',
});

// Получение заголовков с токеном авторизации
export const getAuthHeaders = () => {
  const token = localStorage.getItem('access_token');
  return {
    ...getDefaultHeaders(),
    ...(token && { 'Authorization': `Bearer ${token}` }),
  };
};

// Флаг для предотвращения множественных рефрешей
let isRefreshing = false;
let failedQueue = [];

// Обработка очереди запросов после рефреша
const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

// Конфигурация для хранения токенов
const TOKEN_STORAGE_KEYS = {
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  SESSION_PERSISTENT: 'session_persistent'
};

// Сервис для работы с токенами
export const TokenService = {
  getAccessToken() {
    return localStorage.getItem(TOKEN_STORAGE_KEYS.ACCESS_TOKEN);
  },
  
  getRefreshToken() {
    const isPersistent = localStorage.getItem(TOKEN_STORAGE_KEYS.SESSION_PERSISTENT) === 'true';
    if (isPersistent) {
      return localStorage.getItem(TOKEN_STORAGE_KEYS.REFRESH_TOKEN);
    } else {
      return sessionStorage.getItem(TOKEN_STORAGE_KEYS.REFRESH_TOKEN);
    }
  },
  
  setTokens(accessToken, refreshToken, rememberMe = false) {
    if (accessToken) {
      localStorage.setItem(TOKEN_STORAGE_KEYS.ACCESS_TOKEN, accessToken);
    }
    
    // Флаг persistent сессии
    localStorage.setItem(TOKEN_STORAGE_KEYS.SESSION_PERSISTENT, rememberMe ? 'true' : 'false');
    
    // Refresh token храним в зависимости от rememberMe
    if (refreshToken) {
      if (rememberMe) {
        localStorage.setItem(TOKEN_STORAGE_KEYS.REFRESH_TOKEN, refreshToken);
      } else {
        sessionStorage.setItem(TOKEN_STORAGE_KEYS.REFRESH_TOKEN, refreshToken);
      }
    }
  },
  
  removeTokens() {
    localStorage.removeItem(TOKEN_STORAGE_KEYS.ACCESS_TOKEN);
    localStorage.removeItem(TOKEN_STORAGE_KEYS.REFRESH_TOKEN);
    localStorage.removeItem(TOKEN_STORAGE_KEYS.SESSION_PERSISTENT);
    sessionStorage.removeItem(TOKEN_STORAGE_KEYS.REFRESH_TOKEN);
    localStorage.removeItem('user');
  },
  
  isPersistentSession() {
    return localStorage.getItem(TOKEN_STORAGE_KEYS.SESSION_PERSISTENT) === 'true';
  },
  
  async refreshToken() {
    const refreshToken = this.getRefreshToken();
    if (!refreshToken) {
      throw new Error('Нет refresh_token');
    }
    
    const response = await fetch(API_ENDPOINTS.REFRESH_TOKEN, {
      method: 'POST',
      headers: getDefaultHeaders(),
      body: JSON.stringify({ refresh_token: refreshToken }),
    });
    
    if (!response.ok) {
      throw new Error('Не удалось обновить токен');
    }
    
    const data = await response.json();
    const isPersistent = this.isPersistentSession();
    this.setTokens(data.access_token, data.refresh_token, isPersistent);
    return data.access_token;
  }
};

// Время жизни токена (миллисекунды)
export const TOKEN_LIFETIME = {
  SESSION: 8 * 60 * 60 * 1000,      // 8 часов для обычной сессии
  PERSISTENT: 30 * 24 * 60 * 60 * 1000 // 30 дней для persistent сессии
};

// Функция проверки истечения токена
export const isTokenExpired = (token) => {
  if (!token) return true;
  
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const exp = payload.exp * 1000;
    return Date.now() >= exp;
  } catch {
    return true;
  }
};

// Автоматическая проверка токена при загрузке приложения
export const setupTokenAutoRefresh = () => {
  const intervalId = setInterval(() => {
    const token = TokenService.getAccessToken();
    if (token && isTokenExpired(token)) {
      TokenService.refreshToken().catch((error) => {
        console.error('Failed to refresh token:', error);
        // Если не удалось обновить, перенаправляем на логин
        if (window.location.pathname !== '/login') {
          TokenService.removeTokens();
          window.location.href = '/login';
        }
      });
    }
  }, 60000); // Проверяем каждую минуту
  
  return () => clearInterval(intervalId);
};

// Перехватчик ответов для обработки 401 ошибок
const handle401Error = async (originalRequest) => {
  // Проверяем, не на странице ли логина
  const currentPath = window.location.pathname;
  if (currentPath === '/login') {
    throw new Error('Требуется авторизация');
  }
  
  if (isRefreshing) {
    // Если уже идет рефреш, добавляем в очередь
    return new Promise((resolve, reject) => {
      failedQueue.push({ resolve, reject });
    }).then(token => {
      originalRequest.headers = {
        ...originalRequest.headers,
        'Authorization': `Bearer ${token}`
      };
      return fetch(originalRequest.url, originalRequest);
    }).catch(err => {
      throw err;
    });
  }
  
  isRefreshing = true;
  
  try {
    const newToken = await TokenService.refreshToken();
    processQueue(null, newToken);
    
    // Повторяем оригинальный запрос с новым токеном
    originalRequest.headers = {
      ...originalRequest.headers,
      'Authorization': `Bearer ${newToken}`
    };
    return fetch(originalRequest.url, originalRequest);
  } catch (error) {
    processQueue(error, null);
    TokenService.removeTokens();
    localStorage.removeItem('user');
    
    // Редирект на логин только если не на странице логина
    if (currentPath !== '/login') {
      window.location.replace(`/login?redirect=${encodeURIComponent(currentPath)}&reason=session_expired`);
    }
    
    throw error;
  } finally {
    isRefreshing = false;
  }
};

// Обновленный API клиент с обработкой авторизации
export const apiClient = {
  async request(endpoint, options = {}) {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), API_TIMEOUT);
    
    const config = {
      ...options,
      headers: {
        ...getAuthHeaders(),
        ...options.headers,
      },
      signal: controller.signal,
    };
    
    try {
      const response = await fetch(endpoint, config);
      clearTimeout(timeoutId);
      
      // Если 401 и не запрос логина/рефреша - пробуем рефреш
      if (response.status === 401 && 
          !endpoint.includes('/auth/login') && 
          !endpoint.includes('/auth/refresh')) {
        return handle401Error({ url: endpoint, ...config });
      }
      
      return this.handleResponse(response);
    } catch (error) {
      clearTimeout(timeoutId);
      
      if (error.name === 'AbortError') {
        const timeoutError = new Error('Превышено время ожидания ответа от сервера');
        timeoutError.status = 408;
        throw timeoutError;
      }
      
      throw error;
    }
  },

  async get(endpoint, options = {}) {
    return this.request(endpoint, {
      method: 'GET',
      ...options,
    });
  },

  async post(endpoint, data, options = {}) {
    return this.request(endpoint, {
      method: 'POST',
      body: JSON.stringify(data),
      ...options,
    });
  },

  async put(endpoint, data, options = {}) {
    return this.request(endpoint, {
      method: 'PUT',
      body: JSON.stringify(data),
      ...options,
    });
  },

  async patch(endpoint, data, options = {}) {
    return this.request(endpoint, {
      method: 'PATCH',
      body: JSON.stringify(data),
      ...options,
    });
  },

  async delete(endpoint, options = {}) {
    return this.request(endpoint, {
      method: 'DELETE',
      ...options,
    });
  },

  async uploadFile(endpoint, file, fieldName = 'file', additionalData = {}) {
    const formData = new FormData();
    formData.append(fieldName, file);
    
    // Добавляем дополнительные данные
    Object.keys(additionalData).forEach(key => {
      formData.append(key, additionalData[key]);
    });
    
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), API_TIMEOUT * 2); // Для загрузок даем больше времени
    
    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          ...(localStorage.getItem('access_token') && { 
            'Authorization': `Bearer ${localStorage.getItem('access_token')}` 
          }),
        },
        body: formData,
        signal: controller.signal,
      });
      
      clearTimeout(timeoutId);
      return this.handleResponse(response);
    } catch (error) {
      clearTimeout(timeoutId);
      
      if (error.name === 'AbortError') {
        throw new Error('Превышено время ожидания при загрузке файла');
      }
      
      throw error;
    }
  },

  // Загрузка файла с PUT методом (для обновления существующих ресурсов)
  async uploadFilePut(endpoint, file, fieldName = 'file', additionalData = {}) {
    const formData = new FormData();
    formData.append(fieldName, file);
    
    // Добавляем дополнительные данные
    Object.keys(additionalData).forEach(key => {
      formData.append(key, additionalData[key]);
    });
    
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), API_TIMEOUT * 2);
    
    try {
      const response = await fetch(endpoint, {
        method: 'PUT',
        headers: {
          ...(localStorage.getItem('access_token') && { 
            'Authorization': `Bearer ${localStorage.getItem('access_token')}` 
          }),
        },
        body: formData,
        signal: controller.signal,
      });
      
      clearTimeout(timeoutId);
      return this.handleResponse(response);
    } catch (error) {
      clearTimeout(timeoutId);
      
      if (error.name === 'AbortError') {
        throw new Error('Превышено время ожидания при загрузке файла');
      }
      
      throw error;
    }
  },

  // Загрузка файла с PATCH методом (для частичного обновления)
  async uploadFilePatch(endpoint, file, fieldName = 'file', additionalData = {}) {
    const formData = new FormData();
    if (file) formData.append(fieldName, file);
    
    // Добавляем дополнительные данные
    Object.keys(additionalData).forEach(key => {
      if (additionalData[key] !== null && additionalData[key] !== undefined) {
        formData.append(key, additionalData[key]);
      }
    });
    
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), API_TIMEOUT * 2);
    
    try {
      const response = await fetch(endpoint, {
        method: 'PATCH',
        headers: {
          ...(localStorage.getItem('access_token') && { 
            'Authorization': `Bearer ${localStorage.getItem('access_token')}` 
          }),
        },
        body: formData,
        signal: controller.signal,
      });
      
      clearTimeout(timeoutId);
      return this.handleResponse(response);
    } catch (error) {
      clearTimeout(timeoutId);
      
      if (error.name === 'AbortError') {
        throw new Error('Превышено время ожидания при загрузке файла');
      }
      
      throw error;
    }
  },

  async handleResponse(response) {
    // Обработка 204 No Content
    if (response.status === 204) {
      return { success: true };
    }
    
    // Для ответов без тела (например, некоторые logout)
    const contentType = response.headers.get('content-type');
    if (!contentType || !contentType.includes('application/json')) {
      if (response.ok) {
        return { success: true };
      }
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }
    
    let data;
    try {
      data = await response.json();
    } catch (e) {
      if (response.ok) {
        return { success: true };
      }
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }
    
    if (!response.ok) {
      const error = new Error(data.message || `HTTP ${response.status}: ${response.statusText}`);
      error.status = response.status;
      error.data = data;
      error.errors = data.errors; // Для ошибок валидации
      throw error;
    }
    
    return data;
  },
};

export default API_BASE_URL;